import { Content, ContentType } from "../types/Types";
import _ from "lodash";
import Api from "./DrupalApi";
import { getSelectedLanguage } from "./Language";
import Localforage from "./Localforage";
import { EXPIRY_TIME_IN_SECONDS } from "../config/Constants";
const CONTENT_KEY = "content";
const CURRENT_CARD_KEY = "current_card";

const getContent = async (refresh?: boolean): Promise<Content[]> => {
  const content = await Localforage.getItemWithExpiry<Content[]>(CONTENT_KEY);
  if (content && refresh) {
    return content;
  }
  const { data } = await Api.getContent(getSelectedLanguage());
  await Promise.all([
    Localforage.saveItemWithExpiry(CONTENT_KEY, data, EXPIRY_TIME_IN_SECONDS),
    saveCardsRandomly(data, ContentType.BLUE_CARDS),
    saveCardsRandomly(data, ContentType.GREEN_CARDS),
    saveCardsRandomly(data, ContentType.RED_CARDS),
    saveCardsRandomly(data, ContentType.YELLOW_CARDS),
  ]);
  return data;
};

const filterByContentType = (
  contents: Content[],
  type: ContentType
): Content[] => contents.filter((content) => content.type === type);

const findById = (
  contents: Content[],
  contentId: string
): Content | undefined => contents.find((content) => content.id === contentId);

const saveCardsRandomly = (
  contents: Content[],
  type: ContentType
): Promise<void> => {
  const cards = filterByContentType(contents, type);
  return Localforage.saveItemWithExpiry(
    type,
    _.shuffle(cards),
    EXPIRY_TIME_IN_SECONDS
  );
};

const getRandomCards = async (type: ContentType) => {
  console.log(type);
  const cards = await Localforage.getItemWithExpiry(type);
  console.log(cards);
  return cards;
};

const saveCurrentCard = async (cardId: string, type: ContentType) => {
  const key = `${CURRENT_CARD_KEY}_${type}`;
  console.log(key);
  console.log(cardId);
  const res = await  Localforage.saveItemWithExpiry(key, cardId, EXPIRY_TIME_IN_SECONDS);
};

const getCurrentCard = async (type: ContentType) => {
  return Localforage.getItemWithExpiry(`${CURRENT_CARD_KEY}_${type}`);
};

const getNextCard = async (currentId: string, items: Content[]): Promise<Content> => {
  const currentIndex = items.findIndex((item) => item.id === currentId);
  const next =  await currentIndex === -1 || currentIndex === (items.length - 1)
    ? items[0]
    : items[currentIndex + 1];
    return next;
};

export default {
  filterByContentType,
  getContent,
  findById,
  saveCurrentCard,
  getCurrentCard,
  getNextCard,
  getRandomCards,
};
